import { render, staticRenderFns } from "./TheHeaderDropdownAccount.vue?vue&type=template&id=7931f875&"
import script from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports